import { CampaignDto } from 'services/campaign/campaignService.dto';
import { ItemDto } from 'services/item/itemService.dto';
import {
  ConversationDto,
  ConversationMessagingContext,
  ConversationWithLastMessageDto,
} from 'services/message/messageService.dto';
import { PublicUserDto } from 'services/user/userService.dto';

export const DRAFT_CONVERSATION_ID = 0;

export interface PendingConversation {
  context: ConversationMessagingContext;
  interlocutorId?: number | null;
  objectId?: number;
}

export const isDraftConversation = (conversationId?: number) => conversationId === DRAFT_CONVERSATION_ID;

export const findSupportConversation = (conversations: ConversationWithLastMessageDto[]) =>
  conversations.find(({ conversation }) => conversation.context === 'SUPPORT');

export const findItemConversation = (conversations: ConversationWithLastMessageDto[], userId: number, itemId: number) =>
  conversations.find(({ conversation }) => {
    const { context, item, interlocutors } = conversation;
    return context === 'ITEM' && item?.id === itemId && interlocutors.some(interlocutor => interlocutor.id === userId);
  });

export const findCampaignConversation = (
  conversations: ConversationWithLastMessageDto[],
  userId: number,
  campaignId: number
) =>
  conversations.find(({ conversation }) => {
    const { context, campaign, interlocutors } = conversation;
    return (
      context === 'CAMPAIGN' &&
      campaign?.id === campaignId &&
      interlocutors.some(interlocutor => interlocutor.id === userId)
    );
  });

export const buildDraftConversation = (
  pending: PendingConversation,
  publicUser?: PublicUserDto,
  item?: ItemDto,
  campaign?: CampaignDto
): ConversationDto => {
  const displayName = publicUser
    ? publicUser.organizationName || `${publicUser.firstName} ${publicUser.lastName}`.trim()
    : '';

  return {
    conversationId: DRAFT_CONVERSATION_ID,
    interlocutors: [
      {
        id: pending.interlocutorId ?? 0,
        name: displayName,
        profileImageUrl: publicUser?.imageUrl,
        role: 'UNKNOWN',
        fundraiserVerificationCompleted: publicUser?.fundraiserVerificationCompleted ?? false,
        vip: publicUser?.vip ?? false,
      },
    ],
    item:
      pending.context === 'ITEM' && pending.objectId
        ? {
            id: pending.objectId,
            title: item?.title ?? '',
            imageUrl: item?.imageUrlList?.[0] ?? '',
          }
        : undefined,
    campaign:
      pending.context === 'CAMPAIGN' && pending.objectId
        ? {
            id: pending.objectId,
            title: campaign?.name ?? '',
            imageUrl: campaign?.imageUrls?.[0] ?? '',
          }
        : undefined,
    context: pending.context,
    unreadMessageCount: 0,
    archived: false,
  };
};
